import Transformer from './Transformer';
import Constants from 'src/AAF/Ads/Constans';

class itemTransformPlanSelectorOffers extends Transformer {
    transform(model) {
        return {
            items: this.getItemsPlanSelectorRibbonsADS(model),
        }
    }

    getItemsPlanSelectorRibbonsADS(planesRibons) {
        let ribbons = [{
            items: [],
            type: Constants.PLANSELECTOR
        }];

        if (planesRibons && planesRibons.offers && planesRibons.offers.length > 0) {
            //* Iterar sobre cada oferta en items
            for (const offer of planesRibons.offers) {
                const item = this.parseBackgroundsRibbonsADS(offer);
                ribbons[0].items.push(item);
            }
        }

        //* Extracción de la propiedad items
        let itemsArray = ribbons[0].items;
        const typeRibbon = ribbons[0].type;

        //* Mapear cada elemento de itemsArray y construir un nuevo array
        const mappedItems = itemsArray.map((item, i) => (     
            {
            group_id: i,
            cover: item.background ? item.background.image_aaf : item.background.image_default,
            portrait: item.background ? item.background.image_aaf : item.background.image_default,
            title: item.producttype || '',
            provider: item.producttype || '',
            type: typeRibbon,
            href: item.href.checkout.href,
            logo: item.logo,
            price: item.price,
            translation: item.translation,
            product_id: item.product_id
        }));
        return mappedItems;
    }

    parseBackgroundsRibbonsADS(offer) {
        //* Verificar si offer es un objeto
        if (offer && offer.assets && typeof offer.assets === 'object') {
            const result = {
                producttype: offer.producttype,
                background: {},
                logo: '',
                price: offer.price,
                translation: offer.translation,
                href: offer._links,
                product_id: offer.product_id
            };
            const assets = offer.assets;

            //* Iterar sobre las propiedades de assets (background y logo)
            for (const assetType in assets) {
                if (assets.hasOwnProperty(assetType)) {
                    const asset = assets[assetType];
                    const assetResult = {};

                    //* Verificar si el asset actual es background y tiene las propiedades aaf y default
                    if (assetType === Constants.BACKGROUND && asset.aaf && asset.default) {
                        assetResult.image_aaf = asset.aaf;
                        assetResult.image_default = asset.default;
                    }

                    //* Verificar si el asset actual es logo y tiene la propiedad aaf
                    if (assetType === Constants.LOGO && asset.aaf) {
                        assetResult.logo = asset.aaf;
                    }

                    //* Almacena los resultados en el objeto final
                    result[assetType] = assetResult;
                }
            }
            return result;
        } else {
            return {};
        }
    }
}

export default new itemTransformPlanSelectorOffers();



// WEBPACK FOOTER //
// ./src/requests/transformers/itemTransformPlanSelectorOffers.js